import { combineReducers } from 'redux';
import list from './list.reducer';

const claimReducers = combineReducers({
  list,
});

export default claimReducers;
